// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const MergeContact = t.struct({
    isMergeBusinessContactsFlowActive: t.Boolean,
    selectedContactIdsToMerge: t.list(t.Number),
    initialMergeContactId: t.maybe(t.Number)
}, {
    defaultProps: {
        isMergeBusinessContactsFlowActive: false,
        selectedContactIdsToMerge: [],
        initialMergeContactId: null
    },
    name: 'MergeContact',
    strict: true
});
